import { Component, OnInit, ViewChild } from '@angular/core';
import { MetaService } from 'services/meta.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Location, LocationService } from 'services/location.service';
import { ValidationService } from 'services/validation.service';

@Component({
	selector: 'ras-vip-page',
	templateUrl: './vip-page.component.html',
	styleUrls: ['./vip-page.component.sass']
})
export class VipPageComponent implements OnInit {

	public location = null
	public unit
	public name
	public surname
	public cell
	public email
	public message

	public locations: Location[]
	public busy = false
	public form_sent = false
	public form_error = false
	public show_invalid = false

	constructor(private metaService: MetaService, private http: HttpClient, private locationService: LocationService, public valid: ValidationService) { }

	ngOnInit() {
		this.metaService.apply('vip')

		this.locationService.get_all()
		.then(locations => {
			// Add display_name with area in brackets for locations with duplicate names
			const nameCounts = locations.reduce((acc, loc) => {
				acc[loc.name] = (acc[loc.name] || 0) + 1;
				return acc;
			}, {} as Record<string, number>);

			this.locations = locations.map(loc => ({
				...loc,
				display_name: nameCounts[loc.name] > 1 ? `${loc.name} (${loc.area})` : loc.name
			}));
		})
	}

	send_message() {

		if (!this.location || !this.valid.sa_cell_number(this.cell) || !this.valid.email(this.email) || !this.valid.number(this.unit)) {

			this.show_invalid = true

		} else {

			this.busy = true

			if ((<any>window).dataLayer) (<any>window).dataLayer.push({
				'event': 'formSubmission',
				'formType': 'VIP',
				'formId': 'vip-form'
			});

			try {
				this.http.post(
					'https://rentastore.co.za/backend/contact.php',
					{
						branch: this.location,
						name: this.name,
						surname: this.surname,
						cell: this.cell,
						email: this.email,
						unit: this.unit,
						message: this.message,
					},
					{
						responseType: 'text',
					}
				)
				.toPromise()
				.then(result => {
					this.busy = false
					this.form_sent = true
					this.name = ''
					this.surname = ''
					this.cell = ''
					this.email = ''
					this.unit = ''
					this.message = ''
				}, reason => {
					this.form_error = true
					this.busy = false
				})
			} catch (exception) {
				console.log(exception)
			}

		}
	}

}
